import { observer } from 'mobx-react'
import type { FC } from 'react'

import { tJosa } from '~/@app/i18n'
import { routeName } from '~/@common/constants'
import { commonRepo } from '~/@common/services/repo.service'
import type { IterableItem } from '~/@common/types'
import { SubTabText } from '~/@common/ui/SubTab'

import type { RecentStudyType } from '../../@common/types'
import { recentStudyTypeMenuText } from '../../@common/types'

const TAB_ITEMS: RecentStudyType[] = ['ALL', 'HOMEWORK', 'WORKSHEET', 'WORKBOOK', 'EXAM', 'CAS']

const TAB_META: IterableItem<string, RecentStudyType>[] = TAB_ITEMS.map((value) => ({
  label: recentStudyTypeMenuText[value],
  value,
}))

type Props = {
  activeType: RecentStudyType
  onChangeType: (type: RecentStudyType) => void
}

const RecentStudyTab: FC<Props> = ({ activeType, onChangeType }) => {
  const { byFeature } = commonRepo.permission
  const isExamRestricted = !byFeature.isAllowed('EXAM_WORKSHEET')
  const isCasRestricted = !byFeature.isRouteAllowed(routeName.student.cas)

  const visibleTabs = TAB_META.filter((tab) => {
    if (tab.value === 'EXAM' && isExamRestricted) return false
    if (tab.value === 'CAS' && isCasRestricted) return false
    return true
  })

  return (
    <SubTabText.Group value={activeType} onChange={(v) => onChangeType(v as RecentStudyType)}>
      {visibleTabs.map((tab) => (
        <SubTabText.GroupItem key={tab.value} value={tab.value}>
          {tJosa(tab.label)}
        </SubTabText.GroupItem>
      ))}
    </SubTabText.Group>
  )
}

export default observer(RecentStudyTab)
